module.exports = __webpack_public_path__ + "img/fig09.e5593789.jpg";